module.exports = __webpack_public_path__ + "static/img/e4title.c24e846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e4title.png
// module id = GdJR
// module chunks = 0